import { render, staticRenderFns } from "./DeleteEnvelopeModal.vue?vue&type=template&id=155d9000&lang=pug"
import script from "./DeleteEnvelopeModal.vue?vue&type=script&lang=js"
export * from "./DeleteEnvelopeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports